// extracted by mini-css-extract-plugin
export default {"selectionButtons":"SelectionButtons_selectionButtons__UqpfV"};